import { render, staticRenderFns } from "./previewPop.vue?vue&type=template&id=0401b3c9&scoped=true"
import script from "./previewPop.vue?vue&type=script&lang=js"
export * from "./previewPop.vue?vue&type=script&lang=js"
import style0 from "./previewPop.vue?vue&type=style&index=0&id=0401b3c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0401b3c9",
  null
  
)

export default component.exports